import React, { useState } from "react";
import { motion } from "motion/react";
import Lightbox from "yet-another-react-lightbox";
import {Zoom} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/styles.css";

const PhotoCardsLightbox = ({images}) => {

  const [active, setActive] = useState(false);

  if (!images[0] || !images[1]) return null;
  return (
    <>
      <Lightbox
        open={!!active}
        index={active - 1}
        close={() => setActive(false)}
        slides={images.map(img => ({src: img.url}))}
        plugins={[Zoom]}
      />
      <div className="images">
        <div className="photograph-overlap">
          <motion.div
            className={"photograph photo-hover"}
            style={{ backgroundImage: `url(${images[0].url})`}}
            onClick={() => setActive(1)}
            role={"button"}
          />
          <motion.div
            className={"photograph-sub photo-hover"}
            style={{ backgroundImage: `url(${images[1].url})`}}
            onClick={() => setActive(2)}
            role={"button"}
          />
        </div>
      </div>
    </>
  )
};
export default PhotoCardsLightbox;